import UpdateCustomer from './UpdateCustomer'
export default UpdateCustomer
